import { PLAN_CAPABILITIES } from '../../../lib/planCapabilities.js'

// Assistant-facing alias. The product capability registry is intentionally the
// one source of truth for document import, staged plan actions, UI labels, and
// methodology.
export const PLAN_IMPORT_FIELDS = PLAN_CAPABILITIES
export const PLAN_IMPORT_FIELD_MAP = Object.fromEntries(
  PLAN_IMPORT_FIELDS.map((field) => [field.path, field]),
)

export const CALCULATED_EMPLOYEE_FIELDS = {
  age: { type: 'number', label: 'age' },
  compensation: { type: 'number', label: 'compensation' },
  totalDeferralPercent: { type: 'number', label: 'total deferral percentage' },
  totalEmployeeContribution: { type: 'number', label: 'employee contribution' },
  employerTotal: { type: 'number', label: 'employer contribution' },
  matchAmount: { type: 'number', label: 'employer match' },
  necAmount: { type: 'number', label: 'nonelective contribution' },
  profitSharingAmount: { type: 'number', label: 'profit-sharing contribution' },
  ageWeightedProfitSharingAmount: { type: 'number', label: 'age-weighted profit-sharing contribution' },
  ageWeightedTestingAge: { type: 'number', label: 'age-weighted testing age' },
  cashBalanceCredit: { type: 'number', label: 'cash-balance hypothetical benefit credit' },
  totalContribution: { type: 'number', label: 'total contribution' },
  afterTaxContribution: { type: 'number', label: 'after-tax contribution' },
  balance: { type: 'number', label: 'balance' },
  loanBalance: { type: 'number', label: 'loan balance' },
  isHCE: { type: 'boolean', label: 'HCE status' },
  catchupEligible: { type: 'boolean', label: 'catch-up eligibility' },
  participationStatus: { type: 'string', label: 'participation status' },
  status: { type: 'string', label: 'employment status' },
  gender: { type: 'string', label: 'gender' },
  eligibilityStatus: { type: 'string', label: 'plan eligibility status (eligible / ineligible / ltpt / unknown)' },
}

export const FILTER_OPERATORS = ['eq', 'neq', 'lt', 'lte', 'gt', 'gte', 'contains', 'in']

export function setNestedValue(target, path, value) {
  const segments = String(path).split('.')
  let cursor = target
  segments.forEach((segment, index) => {
    if (index === segments.length - 1) {
      cursor[segment] = value
      return
    }
    cursor[segment] = cursor[segment] && typeof cursor[segment] === 'object'
      ? cursor[segment]
      : {}
    cursor = cursor[segment]
  })
  return target
}

export function getNestedValue(target, path) {
  return String(path).split('.').reduce((value, segment) => value?.[segment], target)
}
